import React, { useEffect, useState } from "react";
import axios from "axios";
import { FcPlus } from "react-icons/fc";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, Grid, Typography } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const AdhocMatrialLines = (props) => {
  let len = props.addMore.length - 1; //length
  let testlen = props.addMore.length - 2;
  let descriptiv = "descriptive" + len; //get id for description
  let test = "test-" + testlen; //last nos test id
  let dstin = "distin-" + len;


  //----------get Last Nos logics start--------
  const [notest, setnotest] = useState();
  const [lastValue, setlastValue] = useState(0);
  function testChange(e) { 
    // var testNo=document.getElementById(test).value
    var billing = document.getElementById("billing").value;
    var date = document.getElementById("date").value;
    
    // console.log('kfk',testNo)
    if (len == 1) {
      var testNo = document.getElementById(test).value;
      var testNos = testNo;
      // setlastValue(testNos)
    } else {
      var testNos = 1;
      // setlastValue(testNos)
    }

    var sr = e.target.sr;
    var finalNoValue = "";
    if (sr === "Mat") {
      var swlvalue = e.target.value;
      if (billing) {
        var lastNo = "";
        if (len == 0) {//if create first row
          axios
            .get(`api/last_nos/${billing}/${date}/`)
            .then((res) => {
              var lastNo = res.data.lastNos;
              var swvalue = Number(lastNo) + Number(swlvalue)-1;
              // if(swvalue != 1){
              //   swvalue+=1;
              // }
              // else{
              //   swvalue=swvalue;
              // }
              console.log(swlvalue, "ALI");
              setlastValue(swvalue+1);
              var finalNoValue;
              if(lastNo == swvalue){
                 finalNoValue = swvalue;
              }
              else if(swlvalue==1){
                finalNoValue = swvalue;
              }
              else{
                finalNoValue = lastNo + " to " + swvalue;
              }
              console.log(finalNoValue, "ALI2");
              setnotest(finalNoValue);
            });
        }
         else { //if create 2nd and 3rd row 
          console.log("ali",lastValue);
          var swvalue = Number(lastValue) + Number(swlvalue) - 1;
          var tens = Math.floor(swlvalue/10 % 10);
          var currentValue = Number(swvalue)- Number(tens);
          // console.log("tens place",swlvalue);
          if(swlvalue.toString().length>1){//get lenth nos no by particuler row
            // console.log('length',swlvalue.toString().length)
            const myArray = swlvalue.split("");
            var currentNumberSkip = Number(myArray[0]); //split array and take first digit and minus during set time
            // console.log('currentValue',Number(myArray[0]));
          }else{
            var currentNumberSkip = 0;
          }
          var myValue = lastValue-tens;
          if(swlvalue==1){
            finalNoValue = myValue;
          }
          else{
            var finalNoValue = myValue + " to " + currentValue;
          }
          
          setlastValue(swvalue + 1 - currentNumberSkip);
          setnotest(finalNoValue);
        }
      }
    }
    setnotest(finalNoValue);
  }

  //----------get Last Nos logics end--------

  

  
  {
    /*-------------------------- get catogeory value ----------------------------------------*/
  }
  const [categorylist, setCategorylist] = useState([]);
  useEffect(() => {
    axios.get(`api/show_categorydetails`).then((res) => {
      if (res.status === 200) {
        // console.log(res.data.categorydetails);
        setCategorylist(res.data.categorydetails);
      }
    });
  }, []);

  const values = categorylist.map((item) => {
    return (
      <option value={categorylist.categoryname}>{item.categoryname}</option>
    );
  });

  {
    /*-------------------------- get sub catogeory value ----------------------------------------*/
  }

  const [subCategory, setsubCategory] = useState([]);
  function handleCategory(event) {
    let categoryName = event.target.value;
    axios.get(`api/subcatgory_details/${categoryName}`).then((res) => {
      if (res.status === 200) {
        setsubCategory({
          ...subCategory,
          [event.target.id]: res.data.subCatgoryDetails,
        });
      }
    });
  }

  {
    /*-------------------------- get Item Name ----------------------------------------*/
  }
  const [items, setItem] = useState([]);
  function handleItem(event) {
    let subCategoryName = event.target.value;
    // var categoryname=document.getElementById("categoryname"+len).value
    // console.log(categoryname);

    axios.get(`api/item_details/${subCategoryName}`).then((res) => {
      if (res.status === 200) {
        setItem({ ...items, [event.target.id]: res.data.itemDetails });
      }
    });
  }

  {
    /*-------------------------- get Desiption value ----------------------------------------*/
  }
  let [description, setDescription] = useState([]);
  function handleDes(event) {
    let item = event.target.value;
    axios.get(`api/description/${item}`).then((res) => {
      if (res.status === 200) {
        let des = res.data.desctiption;
        // setDescription({...description,[event.target.id]:res.data.desctiption});
        document.getElementById(len).value = des;
      }
    });
  }



         /*form of data*/

         








  {
    /*-------------------------- get Desiption length ----------------------------------------*/
  }

  const [lineCount, setlineCount] = useState([]);
  function descriptionLineCount(event) {
    let item = event.target.value;
    const descriptiveId = event.target.name + event.target.id;
    // console.log('getID',event.target.name+event.target.id);

    // let length = event.target.value.length;
    // if(length>70){
    //   var lineCheck = Math.floor(length/60)
    //   // console.log('Length',lineCheck)
    // }else{
    //   var lineCheck = 0;
    // }
    let count = 1; //+lineCheck;
    for (let i = count; i < event.target.value.length; i++) {
      if (event.target.value[i] == "\n") {
        count++;
      }
    }
    // let totalLineCount = lineCount + count;
    // console.log('Previous count',count);
    // setlineCount(count);
    setlineCount({ ...lineCount, [descriptiveId]: count });
  }
  // console.log('Linecount',lineCount);

  // remove line count
  function removecount(val, deletebutton) {
    props.delete(val);
    setlineCount((current) => {
      const copy = { ...current };
      delete copy[deletebutton];
      return copy;
      // remove cost key from object
      // const {cost, ...rest} = current;
      // return rest;
      // console.log(current)
    });
    // console.log('Delete index',Math.round(val.index))
  }

  {
    /*---------------------line count logics ----------------*/
  }
  var count = Object.keys(lineCount).length;

  var checklineCount = 0;

  for (let index = 0; index < count; index++) {
    if (len >= index) {
      let indexche = "descriptive" + index;
      // console.log('Index',indexche)
      if (indexche in lineCount) {
        checklineCount += lineCount[indexche];
        // console.log('checklineCount',checklineCount)
      }
    }
  }
  // const [totalLine, settotalLine] = useState([checklineCount]);

  // console.log('Total count',checklineCount)

  // props.delete()

  {
    /*-------------------------- Submit and add more button disabled after line count 16 -----------------------------------*/
  }
  if (checklineCount > 15) {
    alert("use max 12 lines ");
    // hide("#button")
    document.getElementById("submit").disabled = true;
    // document.getElementById("plusButton").disabled = true;
    // ("#button").remove();
  } else if (checklineCount < 15) {
    // document.getElementById("submit").disabled = false;
    const button = document.getElementById("submit");
    // console.log(button);
    // const buttonPlus = document.getElementById('plusButton').disabled=true;
    if (button != null) {
      button.disabled = false;
    }
  }

  return props.addMore.map((val, idx) => {
    let 
    sr = `sr-${idx}`,
      HSN = `HSN-${idx}`,
      certificate_id = `certificate_id-${idx}`,
      Chapt = `Chapt-${idx}`,
      Mat = `Mat-${idx}`,
      rate = `rate-${idx}`,
      QTY = `QTY-${idx}`,
      AMT = `AMT-${idx}`,
      
      
      deletebutton = `descriptive${idx}`;
    //console.log(val.index);
    return (
      <tr key={val.index}>


       
    <td>
    <input
    type="text" // Assuming "sr" is a text input
    style={{
      paddingTop: "20px",
      paddingBottom: "10px",
      marginTop: "3px",
    }}
    name="sr"
    id={sr}
    data-id={idx + 1}
    className="form-control"
    value={idx + 1} // Set the value to idx + 1
    readOnly // Make it read-only if necessary
  />
      </td>       

        {/*<td>
            <input type="text"  style={{paddingTop: "30px",paddingBottom: "30px",marginTop:"12px"}} height="100" name="sn" id={sn} data-id={idx} className="form-control " />
          </td>*/}


<td>
          <input
            name="HSN"
                       
            data-id={idx}
            id={HSN}
            className="form-control"

            style={{
              paddingTop: "20px",
              
             paddingBottom: "10px",
              marginTop: "3px",
            }}
            required
          ></input>        
      </td>

      <td>
          <input
            name="certificate_id"
                       
            data-id={idx}
            id={certificate_id}
            className="form-control"

            style={{
              paddingTop: "20px",
              
             paddingBottom: "10px",
              marginTop: "3px",
            }}
          ></input>        
      </td>
 
      
        
      <td>
          <textarea
            name="Chapt"
              rows="1"
            data-id={idx}
            id={Chapt}
            className="form-control"

            style={{
              paddingTop: "20px",
              
             paddingBottom: "10px",
              marginTop: "3px",
            }}
            required // Add the required attribute here

          ></textarea>
        </td>
       
        <td>
          <textarea
            name="Mat"
            rows="1"
            data-id={idx}
            id={Mat}
            className="form-control"

            style={{
              paddingTop: "20px",
              
             paddingBottom: "10px",
              marginTop: "3px",
            }}
            required
          ></textarea>
   
 </td>

        <td>
          <input
            name="rate"
           data-id={idx}
            id={rate}
            className="form-control"

            style={{
              paddingTop: "20px",
              
             paddingBottom: "10px",
              marginTop: "3px",
            }}
            onChange={(e) => {
              const rate= parseFloat(e.target.value) || 0;
              const qty = parseFloat(document.getElementById(`QTY-${idx}`).value) || 0;
              const amt = qty * rate;
        
              // Update the value of "AMT" directly
              document.getElementById(`AMT-${idx}`).value = amt;
            }}
            required
          ></input>
        </td>

        <td>
          <input
            name="QTY"
                       
            data-id={idx}
            id={QTY}
            className="form-control"

            style={{
              paddingTop: "20px",
              
             paddingBottom: "10px",
              marginTop: "3px",
            }}
            onChange={(e) => {
              const qty = parseFloat(e.target.value) || 0;
              const rate = parseFloat(document.getElementById(`rate-${idx}`).value) || 0;
              const amt = qty * rate;
              //console.log("Calculated AMT:", amt);

              // Update the value of "AMT" directly
              document.getElementById(`AMT-${idx}`).value = amt;
            }}
            required
          ></input>
        </td>

        <td>
          <input
            name="AMT"
                        
            data-id={idx}
            id={AMT}
            className="form-control"
            
            style={{
              paddingTop: "20px",  
              paddingBottom: "10px",
              marginTop: "3px",
              width: "70px", 
            }}
            readOnly

          ></input>
        </td>
        
        <td>
          {idx === 0 ? (
            checklineCount < 16 ? (
              <Button
                title="Add More"
                style={{
                  color: "white",
                  marginTop: "30px",
                  minWidth: "0px",
                  padding: "0px",
                }}
                onClick={() => props.add()}
                type="button"
              >
                <FcPlus />
              </Button>
            ) : (
              console.log("jjd")
            )
          ) : (
            <Button
              id={deletebutton}
              startIcon={<DeleteIcon color="inherit" />}
              style={{
                color: "#cc0000",
                marginTop: "30px",
                minWidth: "0px",
                padding: "0px",
              }}
              onClick={() => removecount(val, deletebutton)}
            ></Button>
          )}
        </td>
      </tr>
    );
  });
};
export default AdhocMatrialLines;

